import { render } from "./IconSubscription.vue.js?vue&type=template&id=5f6c0a94!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconSubscription.vue?vue&type=template&id=5f6c0a94"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__